import { useMutation, useQuery } from "@tanstack/react-query";
import { ConsentApiClient } from "../api-client/api-client";
import { ResponseSubmitDocumentConsent, SubmitDocumentConsentParams } from "../types";

export const useDocumentsConsent = () => {
  const ListDocumentsQuery = () =>
    useQuery({
      queryKey: ["consent", "documents"],
      queryFn: () => ConsentApiClient.listDocumentsConsent()
    });

  const SubmitDocumentConsentMutation = () =>
    useMutation<ResponseSubmitDocumentConsent, Error, SubmitDocumentConsentParams>({
      mutationFn: async (data) => await ConsentApiClient.submitDocumentConsent(data)
    });

  return { ListDocumentsQuery, SubmitDocumentConsentMutation };
};
